<template>
<div>
  <vue-headful :title="site_title" />
  <template v-if="response && this.response.threadId">
    Thread found, redirecting...
  </template>
  <template v-else>
    {{response}}
  </template>
</div>
</template>

<script>
export default {
  components: {},
  data: function() {
    return {
      response: null
    }
  },
  async created() {
    console.time("PageLoadTime");
    let dateEarly = new Date();
    let postId = 0;
    if (this.$route.query.p) {
      postId = this.$route.query.p;
    }
    let response = await fetch(this.getNodePath() + 'misc/findpost/' + postId);
    let dateLater = new Date();
    this.response = await response.json();
    this.loadTime = this.spanSeconds(dateEarly, dateLater);
    console.timeEnd("PageLoadTime");

    if (this.response.threadId) {
      if (window.location.port) {
        //let redirectTo = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/index.php?showtopic=" + this.response.threadId + "&st=" + this.response.st;
        //console.log(redirectTo);
        window.location.href = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/index.php?showtopic=" + this.response.threadId + "&st=" + this.response.st + "#" + postId;
      } else {
        //let redirectTo = window.location.protocol + "//" + window.location.hostname + "/index.php?showtopic=" + this.response.threadId + "&st=" + this.response.st;
        //console.log(redirectTo);
        window.location.href = window.location.protocol + "//" + window.location.hostname + "/index.php?showtopic=" + this.response.threadId + "&st=" + this.response.st + "#" + postId;
      }
    }
  },
}
</script>

<style lang="scss">

</style>
